import * as Types from '../../../@types/graphql-types';

import { PopularTitleGraphqlFragment } from '../fragments/PopularTitle.fragment';
import gql from 'graphql-tag';
import { PopularTitleGraphqlFragmentDoc } from '../fragments/PopularTitle.fragment';
export type GetPopularTitlesQueryVariables = Types.Exact<{
	allowSponsoredRecommendations?: Types.Maybe<Types.SponsoredRecommendationsInput>;
	backdropProfile?: Types.Maybe<Types.BackdropProfile>;
	country: Types.Scalars['Country'];
	first?: Types.Scalars['Int'];
	format?: Types.Maybe<Types.ImageFormat>;
	language: Types.Scalars['Language'];
	platform?: Types.Platform;
	popularAfterCursor?: Types.Maybe<Types.Scalars['String']>;
	popularTitlesFilter?: Types.Maybe<Types.TitleFilter>;
	popularTitlesSortBy?: Types.PopularTitlesSorting;
	profile?: Types.Maybe<Types.PosterProfile>;
	sortRandomSeed?: Types.Scalars['Int'];
	watchNowFilter: Types.WatchNowOfferFilter;
}>;

export type GetPopularTitlesQuery = { __typename?: 'Query' } & {
	popularTitles: { __typename?: 'PopularTitlesConnection' } & Pick<Types.PopularTitlesConnection, 'totalCount'> & {
			edges?: Types.Maybe<Array<{ __typename?: 'PopularTitlesEdge' } & PopularTitleGraphqlFragment>>;
			sponsoredAd?: Types.Maybe<{ __typename?: 'SponsoredRecommendationAd' } & SponsoredAdFragmentFragment>;
			pageInfo: { __typename?: 'PageInfo' } & Pick<
				Types.PageInfo,
				'startCursor' | 'endCursor' | 'hasPreviousPage' | 'hasNextPage'
			>;
		};
};

export type SponsoredAdFragmentFragment = { __typename?: 'SponsoredRecommendationAd' } & Pick<
	Types.SponsoredRecommendationAd,
	'bidId' | 'holdoutGroup'
> & {
		campaign: { __typename?: 'SponsoredRecommendationCampaign' } & Pick<
			Types.SponsoredRecommendationCampaign,
			'hideRatings' | 'promotionalImageUrl' | 'watchNowLabel'
		> & {
				externalTrackers: Array<
					{ __typename?: 'ExternalTracker' } & Pick<Types.ExternalTracker, 'type' | 'data'>
				>;
				watchNowOffer: { __typename?: 'Offer' } & Pick<
					Types.Offer,
					'standardWebURL' | 'presentationType' | 'monetizationType'
				> & {
						package: { __typename?: 'Package' } & Pick<
							Types.Package,
							'id' | 'packageId' | 'shortName' | 'clearName' | 'icon'
						>;
					};
				node:
					| ({ __typename?: 'Article' } & Pick<Types.Article, 'id'>)
					| ({ __typename?: 'Author' } & Pick<Types.Author, 'id'>)
					| ({ __typename?: 'Bundle' } & Pick<Types.Bundle, 'id'>)
					| ({ __typename?: 'Device' } & Pick<Types.Device, 'id'>)
					| ({ __typename?: 'Episode' } & Pick<Types.Episode, 'id'>)
					| ({ __typename?: 'GenericTitleList' } & Pick<Types.GenericTitleList, 'id'>)
					| ({ __typename?: 'Genre' } & Pick<Types.Genre, 'id'>)
					| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'objectId' | 'objectType' | 'id'> & {
								content: { __typename?: 'MovieContent' } & Pick<
									Types.MovieContent,
									'fullPath' | 'posterUrl' | 'title' | 'originalReleaseYear' | 'isReleased'
								> & {
										scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
										externalIds: { __typename?: 'ExternalIds' } & Pick<Types.ExternalIds, 'imdbId'>;
										backdrops: Array<
											{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>
										>;
									};
								offers: Array<
									{ __typename?: 'Offer' } & Pick<
										Types.Offer,
										'monetizationType' | 'presentationType' | 'id'
									> & {
											package: { __typename?: 'Package' } & Pick<
												Types.Package,
												'id' | 'packageId'
											>;
										}
								>;
								watchlistEntry?: Types.Maybe<
									{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
								>;
							})
					| ({ __typename?: 'MultiStepSportEvent' } & Pick<Types.MultiStepSportEvent, 'id'>)
					| ({ __typename?: 'Offer' } & Pick<Types.Offer, 'id'>)
					| ({ __typename?: 'Package' } & Pick<Types.Package, 'id'>)
					| ({ __typename?: 'Page' } & Pick<Types.Page, 'id'>)
					| ({ __typename?: 'Person' } & Pick<Types.Person, 'id'>)
					| ({ __typename?: 'Season' } & Pick<Types.Season, 'id'>)
					| ({ __typename?: 'Show' } & Pick<Types.Show, 'objectId' | 'objectType' | 'id'> & {
								content: { __typename?: 'ShowContent' } & Pick<
									Types.ShowContent,
									'fullPath' | 'posterUrl' | 'title' | 'originalReleaseYear' | 'isReleased'
								> & {
										scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
										externalIds: { __typename?: 'ExternalIds' } & Pick<Types.ExternalIds, 'imdbId'>;
										backdrops: Array<
											{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>
										>;
									};
								offers: Array<
									{ __typename?: 'Offer' } & Pick<
										Types.Offer,
										'monetizationType' | 'presentationType' | 'id'
									> & {
											package: { __typename?: 'Package' } & Pick<
												Types.Package,
												'id' | 'packageId'
											>;
										}
								>;
								watchlistEntry?: Types.Maybe<
									{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
								>;
								seenState: { __typename?: 'ShowSeenState' } & Pick<
									Types.ShowSeenState,
									'seenEpisodeCount'
								>;
							})
					| ({ __typename?: 'SingleStepSportEvent' } & Pick<Types.SingleStepSportEvent, 'id'>)
					| ({ __typename?: 'SportCompetitionV2' } & Pick<Types.SportCompetitionV2, 'id'>)
					| ({ __typename?: 'SportCompetitorV2' } & Pick<Types.SportCompetitorV2, 'id'>)
					| ({ __typename?: 'Url' } & Pick<Types.Url, 'id'>);
			};
	};

export const SponsoredAdFragmentFragmentDoc = gql`
	fragment SponsoredAdFragment on SponsoredRecommendationAd {
		bidId
		campaign {
			externalTrackers {
				type
				data
			}
			hideRatings
			promotionalImageUrl
			watchNowLabel
			watchNowOffer {
				standardWebURL
				presentationType
				monetizationType
				package {
					id
					packageId
					shortName
					clearName
					icon
				}
			}
			node {
				id
				... on MovieOrShow {
					content(country: $country, language: $language) {
						fullPath
						posterUrl
						title
						originalReleaseYear
						scoring {
							imdbScore
						}
						externalIds {
							imdbId
						}
						backdrops(format: $format, profile: $backdropProfile) {
							backdropUrl
						}
						isReleased
					}
					objectId
					objectType
					offers(country: $country, platform: $platform) {
						monetizationType
						presentationType
						package {
							id
							packageId
						}
						id
					}
					watchlistEntry {
						createdAt
					}
				}
				... on Show {
					seenState(country: $country) {
						seenEpisodeCount
					}
				}
			}
		}
		holdoutGroup
	}
`;
export const GetPopularTitlesDocument = gql`
	query GetPopularTitles(
		$allowSponsoredRecommendations: SponsoredRecommendationsInput
		$backdropProfile: BackdropProfile
		$country: Country!
		$first: Int! = 40
		$format: ImageFormat
		$language: Language!
		$platform: Platform! = WEB
		$popularAfterCursor: String
		$popularTitlesFilter: TitleFilter
		$popularTitlesSortBy: PopularTitlesSorting! = POPULAR
		$profile: PosterProfile
		$sortRandomSeed: Int! = 0
		$watchNowFilter: WatchNowOfferFilter!
	) {
		popularTitles(
			after: $popularAfterCursor
			allowSponsoredRecommendations: $allowSponsoredRecommendations
			country: $country
			filter: $popularTitlesFilter
			first: $first
			sortBy: $popularTitlesSortBy
			sortRandomSeed: $sortRandomSeed
		) {
			edges {
				...PopularTitleGraphql
			}
			sponsoredAd {
				...SponsoredAdFragment
			}
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			totalCount
		}
	}
	${PopularTitleGraphqlFragmentDoc}
	${SponsoredAdFragmentFragmentDoc}
`;
